import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';


@Component({
  selector: 'app-vegboost-active',
  templateUrl: './vegboost-active.component.html',
  styleUrls: ['./vegboost-active.component.scss'],
})
export class VegboostActiveComponent{
  // Input para receber dados do componente pai
  @Input() userData: any;
  @Input() refreshMyData!: () => Promise<void>; 
  @Input() srcIconBoost: string = '';
  // Outputs para comunicação com o componente pai
  @Output() boostClicked = new EventEmitter<void>();
  @Output() purchaseClicked = new EventEmitter<string>();
  public countdown: string = '';
  intervalId: any;

  constructor(private modalCtrl: ModalController,
              private translate: TranslateService,
              public userService: UserService,
              public toastCtrl: ToastController,
              public util: UtilService,
              private analytics: AnalyticsService,
  ) {}
  ngOnInit() {
    this.startCountdown();
  }
  
  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startCountdown() {
    this.updateCountdown();
    this.intervalId = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    if (!this.userData?.vegBoost?.dateEndClient) {
      this.countdown = '';
      return;
    }

    const endTime = new Date(this.userData.vegBoost.dateEndClient).getTime();
    const now = new Date().getTime();
    const timeLeft = endTime - now;

    if (timeLeft <= 0) {
      this.countdown = '';
      clearInterval(this.intervalId);
      return;
    }

    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    this.countdown = `${hours}:${minutes}:${seconds}`;
  }
  // Fechar modal
  dismiss() {
    console.log('userData:', this.userData);
    this.modalCtrl.dismiss();
  }

}
